import { useSliderPointerValue } from "../context.js";
import { ThumbnailRoot } from "../../thumbnail/root.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/slider/thumbnail/root.tsx
/**
* Resolves, sizes, and clips the thumbnail at the slider pointer.
*
* Render `Slider.Thumbnail.Image` inside it for the controlled image. Other children can provide loading indicators,
* overlays, or temporary presentation layers.
*/
const SliderThumbnailRoot = forwardRef(function SliderThumbnailRoot(componentProps, forwardedRef) {
	const pointerValue = useSliderPointerValue();
	return /* @__PURE__ */ jsx(ThumbnailRoot, {
		ref: forwardedRef,
		...componentProps,
		time: pointerValue
	});
});
//#endregion
export { SliderThumbnailRoot };

//# sourceMappingURL=root.js.map